import { Theme, makeStyles, createStyles } from '@material-ui/core/styles';
import { BrandColors } from '../../constants/brandColors';

export const genericJourneyTheme = makeStyles((theme: Theme) => {
  return createStyles({
    journeyThemeGrid: {
      height: 'calc(100vh - 40px)',
      position: 'relative',
      padding: '3.1875rem 0',
      marginLeft: 'auto',
      marginRight: 'auto',
      maxWidth: '800px',
      width: '100%',
      [theme.breakpoints.up('md')]: {
        height: 'calc(100vh - 50px)',
      },
      [theme.breakpoints.up('lg')]: {
        height: 'calc(100vh - 147px)',
      },
      [theme.breakpoints.up('xl')]: {
        padding: '3.1875rem 0',
      },
    },
    fullHeightGrid: {
      height: 'calc(100vh - 40px)',
      [theme.breakpoints.up('md')]: {
        height: 'calc(100vh - 50px)',
      },
      [theme.breakpoints.up('lg')]: {
        height: 'calc(100vh - 147px)',
      },
    },
    journeyThemePaper: {
      height: 'auto !important',
      maxHeight: '100%',
      position: 'relative',
      zIndex: 1,
      marginLeft: '0.6rem',
      marginRight: '0.6rem',
      borderRadius: '0.3125rem',
      maxWidth: 800,
      padding: '1.25rem 1rem 1.25rem 1rem',
      width: 'calc(100% - 1.2rem) !important',
      [theme.breakpoints.up('lg')]: {
        paddingLeft: '1.5rem',
        paddingRight: '1.3rem',
      },
    },
    loginPaper: {
      minHeight: '550px',
    },
    ssoLoginPaper: {
      minHeight: '475px',
    },
    bodyScroll: {
      overflow: 'auto',
    },
    journeyThemeScroll: {
      overflow: 'auto',
      paddingRight: '0rem',
      paddingBottom: '1rem',
      marginTop: '1rem',
      width: '100%',
      '&': {
        scrollbarWidth: 'none',
      },
      '&::-webkit-scrollbar': {
        width: '0',
        height: '0',
      },
      [theme.breakpoints.up('lg')]: {
        paddingRight: '1rem',
        '&': {
          scrollbarWidth: 'thin',
        },
        '&::-webkit-scrollbar': {
          width: '0.5rem',
          height: '0.5rem',
        },
      },
    },
    upLayer: {
      position: 'relative',
      zIndex: 100,
    },
    hasScroll: {
      paddingRight: '0.8125rem',
    },
    customDivider: {
      backgroundColor: `${theme.palette.background.paper}`,
      height: '5px',
      boxShadow: `0px 2px 3px  ${BrandColors.blackWithOpacity15}`,
      marginLeft: '-1rem',
      marginRight: '-0.8125rem',
      [theme.breakpoints.up('lg')]: {
        marginLeft: '-1.5rem',
        marginRight: '-1.3rem',
      },
    },
    customBackButton: {
      height: '60px',
      marginTop: '-25px !Important',
      paddingTop: '1px',
    },
    bottomShadow: {
      position: 'relative',
      '&::before': {
        content: '""',
        height: '60px',
        width: '100%',
        position: 'absolute',
        left: '0rem',
        bottom: '0rem',
        background: `linear-gradient(180deg, ${BrandColors.scoreCardBg}  0%, ${theme.palette.background.paper} 68.33%)`,
        borderRadius: '0 0 0.3125rem 0.3125rem',
        zIndex: 1,
        [theme.breakpoints.up('lg')]: {
          bottom: '70px',
          width: 'calc(100% - 30px)',
        },
      },
    },
    startNewTaskScroll: {
      maxHeight: 'calc(100vh - 225px)',

      [theme.breakpoints.up('lg')]: {
        maxHeight: 'calc(100vh - 460px)',
      },
    },
    newTaskPaper: {
      marginTop: '0',
      marginBottom: '0',
    },
    toDoList: {
      paddingBottom: '0',
      marginTop: '0',
      paddingRight: '0rem',
      maxHeight: 'calc(100vh - 250px)',
      [theme.breakpoints.up('sm')]: {
        maxHeight: 'calc(100vh - 260px)',
      },
      [theme.breakpoints.up('lg')]: {
        maxHeight: 'calc(100vh - 397px)',
        '&': {
          scrollbarWidth: 'none',
        },
        '&::-webkit-scrollbar': {
          width: '0rem',
          height: '0rem',
        },
      },
    },
    CommonQuizScroll: {
      maxHeight: 'calc(100vh - 198px)',
      [theme.breakpoints.up('lg')]: {
        maxHeight: 'calc(100vh - 373px)',
      },
    },
    quizFontStyle: {
      '& .heading': {
        fontSize: '20px',

        lineHeight: '30px',
      },

      '& p, & li': {
        fontSize: '14px',

        lineHeight: '20px',
      },
    },

    quizBlockFontStyle: {
      '& .heading': {
        fontSize: '14px',

        lineHeight: '20px',
      },

      '& p, & li': {
        fontSize: '12px !important',

        lineHeight: '18px',
      },
    },
    summaryFeedback: {
      position: 'relative',
      top: '-100px',
      [theme.breakpoints.up('xs')]: {
        position: 'relative',
        top: '0px',
      },
      [theme.breakpoints.up('sm')]: {
        position: 'relative',
        top: '0px',
      },
    },
    endPageScroll: {
      maxHeight: 'calc(100vh - 182px)',
      [theme.breakpoints.up('lg')]: {
        maxHeight: 'calc(100vh - 380px)',
      },
    },
    endPageStyle: {
      textAlign: 'center',
      '& h2': {
        fontSize: '18px',
        marginTop: '0',
        marginBottom: '0',
      },
      '& p': {
        fontSize: '14px',
        lineHeight: '22px',
        marginTop: '15px',
        marginBottom: '15px',
        '& span': {
          backgroundColor: 'transparent !important',
        },
      },
      '& h1': {
        marginTop: '0',
        '&::after': {
          borderBottom: '1px solid',
        },
      },
    },
    linkGrid: {
      flexWrap: 'wrap',
      '& .link': {
        borderBottom: `1px solid ${theme.palette.background.default}`,
        paddingTop: '20px',
        paddingBottom: '20px',
        '&:last-child': {
          borderBottom: '0',
          paddingBottom: '0',
        },
      },
    },
    bottomShadowHurdle: {
      '&::before': {
        [theme.breakpoints.up('lg')]: {
          bottom: '0px',
        },
      },
    },
    fixedBG: {
      position: 'fixed',
      left: 0,
      top: 0,
      height: '100%',
      width: '100%',
      zIndex: 0,
    },
    ImgContainer: {
      height: '100%',
      width: '100%',
      objectFit: 'cover',
    },
    languageOverlay: {
      '&::before': {
        content: '""',
        position: 'fixed',
        left: 0,
        top: 0,
        backgroundColor: `${BrandColors.blackWithOpacity25}`,
        height: '100%',
        width: '100%',
      },
    },
  });
});
